import React, { useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    changeMobileNumberRequest,
    changePasswordRequest,
    changeProfileNameRequest,
    logoutAuthRequest,
    profileChangeHomeAddressRequest,
    profilePictureUploadRequest,
} from "../../../../_redux/_actions";

import * as yup from "yup";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiButtonPrimary } from "../../../_uiComponents/form/UiButton";

import CloseWhiteIcon from "../../../../styles/img/svg/CloseWhiteIcon";
import FooterTermsLogo from "../../../../styles/img/footer-terms-icon.png";
import { EyeIcon } from "../../../../styles/img/svg/EyeIcon";
import { EyeIconCross } from "../../../../styles/img/svg/EyeIconCross";

import { useSpring, animated } from "@react-spring/web";
import { Context } from "../../../../_context/Store";
import {
    UiNavTabs,
    UiNavTab,
} from "../../../../components/_uiComponents/common/UiNavTabs";
import ChangePasswordOtpVerification from "../forms/ChangePasswordOtpVerification";
import ChangeMobileNumber from "../forms/ChangeMobileNumber";
import ChangePassword from "../forms/ChnagePassword";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { authConstants } from "../../../../_redux/_constants";
import { UiCheckboxInput, UiInput } from "../../../_uiComponents/form/UiInput";
import UiTopRightSection from "../../../_uiComponents/common/custom/header/UiTopRightSection";
import PrivacyPolicyModal from "../PrivacyPolicyModal";
import CookiePolicyModal from "../CookiePolicyModal";
import RulesAndTermsModal from "../RulesAndTermsModal";
import UiCropFileUpload from "../../../_uiComponents/form/UiCropFileUpload";
import { PencilIcon } from "../../../../styles/img/svg/PencilIcon";
import NotificationForm from "../forms/NotificationForm";
import UiCropFileUploadForm from "../forms/UiCropFileUpload";
import ChangeAddress from "../forms/ChangeAddress";
import ChangeProfileName from "../forms/ChangeProfileName";
import defaultProfilePic from "../../../../styles/img/default_profile_picture.png";
import {
    participantTypeIds,
    participantJobRoleIds,
} from "../../../../_redux/_constants";

const validateSchema = () =>
    yup.object().shape({
        email: yup.string().email("Email must be a valid email."),
        mobile: yup.string(),
    });
const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export const UiProfileInfo = (props) => {
    const [editMode, setEditMode] = useState(false);
    const [nameEditMode, setNameEditMode] = useState(false);
    const [addressEditMode, setAddressEditMode] = useState(false);
    const [homeAddress, setHomeAddress] = useState(false);
    const [workAddress, setWorkAddress] = useState(true);
    const [networkContent, setNetworkContent] = useState(false);
    const [cropImageArea, setCropImageArea] = useState(false);
    const [mobileShow, setMobileShow] = useState(false);
    const [otpVerifyShow, setOtpVerifyShow] = useState(false);
    const [otpMobileVerifyShow, setOtpMobileVerifyShow] = useState(false);
    const [notification, setNotification] = useState([]);

    const {
        auth,
        pointsBalance,
        userPrePasswordChangeData,
        userPreMobileDetails,
        imageUpload,
    } = useSelector((state) => {
        return {
            auth: state.auth,
            pointsBalance: state.user.pointsBalance,
            userPrePasswordChangeData: state.auth.userPrePasswordChangeData,
            userPreMobileDetails: state.auth.userPreMobileDetails,
            imageUpload: state.common.uploadImage,
        };
    });

    const actionDispatch = useDispatch();

    const navigate = useNavigate();

    const logOut = () => {
        actionDispatch(logoutAuthRequest({ navigate }));
    };

    const submit = async (values) => {
        setEditMode(false);
    };
    const handleCancel = () => {
        setEditMode(false);
    };

    const editProfile = () => {
        setEditMode(!editMode);
    };
    const toggleWorkAddress = () => {
        setWorkAddress(true);
        setHomeAddress(false);
    };

    const toggleHomeAddress = () => {
        setHomeAddress(true);
        setWorkAddress(false);
    };

    const arrowClick = () => {
        setNetworkContent(!networkContent);
    };

    const properties = useSpring({
        left: props.show ? window.innerWidth - 375 : window.innerWidth,
        position: "fixed",
        top: 0,
        right: 0,
        overflowY: "scroll",
        zIndex: "10000000",
        maxHeight: "100vh",
    });

    const [state, dispatch] = useContext(Context);

    const showTermsModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Rules & Terms of Use",
                subTitle: "Accept to progress",
                children: <RulesAndTermsModal />,
            },
        });
    };

    const showPrivacyModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Privacy Policy",
                subTitle: "Accept to progress",
                children: <PrivacyPolicyModal />,
            },
        });
    };

    const showCookieModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Cookie Policy",
                subTitle: "Keeping you informed",
                children: <CookiePolicyModal />,
            },
        });
    };

    const showOtpFlow = () => {
        if (otpVerifyShow) {
            setOtpVerifyShow(false);
        } else {
            setOtpVerifyShow(true);
        }
    };

    const showOtpMobileFlow = () => {
        if (otpMobileVerifyShow) {
            setOtpMobileVerifyShow(false);
        } else {
            setOtpMobileVerifyShow(true);
        }
    };

    const handlePwdUpdate = async (values) => {
        const browserFingerprint = await getFingerPrint();
        const payload = {
            applicationId: 1,
            validateOtp: false,
            browserFingerprint: browserFingerprint,
            otp: "",
            type: authConstants.CHANGE_PASSWORD,
            ...values,
        };
        actionDispatch(
            changePasswordRequest({
                ...payload,
                showOtpFlow,
            }),
        );
    };
    const handleOtpVerify = (values) => {
        const payload = {
            applicationId: userPrePasswordChangeData?.applicationId,
            validateOtp: true,
            browserFingerprint: userPrePasswordChangeData?.browserFingerprint,
            otp: values.otpVerify,
            currentPassword: userPrePasswordChangeData?.currentPassword,
            newPassword: userPrePasswordChangeData?.newPassword,
            confirmedNewPassword:
                userPrePasswordChangeData?.confirmedNewPassword,
            type: authConstants.SEND_OTP_CHANGE_PASSWORD,
        };

        actionDispatch(
            changePasswordRequest({
                ...payload,
                showOtpFlow,
            }),
        );
    };

    const changeHomeAddress = (payload) => {
        actionDispatch(
            profileChangeHomeAddressRequest({
                ...payload,
                setAddressEditMode,
            }),
        );
    };

    const changeProfileName = (payload) => {
        actionDispatch(
            changeProfileNameRequest({
                ...payload,
                setNameEditMode,
            }),
        );
    };

    const handleOtpMobileChangeVerify = (values) => {
        const payload = {
            applicationId: userPreMobileDetails.applicationId,
            validateOtp: true,
            browserFingerprint: userPreMobileDetails.browserFingerprint,
            newPhoneNumber: userPreMobileDetails?.newPhoneNumber,
            otp: values.otpVerify,
            type: authConstants.SEND_OTP_CHANGE_MOBILE_NUMBER,
            ...values,
        };

        actionDispatch(
            changeMobileNumberRequest({
                ...payload,
                showOtpMobileFlow,
            }),
        );
    };

    const handleMobileUpdate = async (values) => {
        const browserFingerprint = await getFingerPrint();
        const payload = {
            applicationId: 1,
            validateOtp: false,
            browserFingerprint: browserFingerprint,
            otp: "",
            type: authConstants.CHANGE_MOBILE_NUMBER,
            currentMobile: values.currentMobile,
            newPhoneNumber: values.newPhoneNumber,
        };

        actionDispatch(
            changeMobileNumberRequest({
                ...payload,
                showOtpMobileFlow,
            }),
        );
    };

    return (
        <>
            <div className={props.show ? "sb-prof-show" : "sb-prof-hide"}>
                <animated.div style={properties}>
                    <div className="sb-prof-expanded sb-tab-profile-top-wr">
                        <div className="sb-top-right-section-card">
                            <UiTopRightSection />
                        </div>

                        <div className="sb-prof-expanded__header">
                            <span
                                className="sb-prof-close-icon"
                                onClick={props.closeProfile}
                            >
                                <CloseWhiteIcon />
                            </span>
                        </div>
                        <UiNavTabs>
                            <UiNavTab eventKey="Profile" title="Profile">
                                <div className="sb-prof-tab-profile">
                                    {/* {auth?.userProfileDetails?.profileImageUrl !== "" ? <img src={auth?.userProfileDetails.profileImageUrl} /> : <img src={defaultProfilePic} />} */}
                                    {!cropImageArea && (
                                        <>
                                            <div className="sb-prof-expanded__header-wrapper">
                                                {auth?.userProfileDetails
                                                    ?.profileImageUrl !== "" ? (
                                                    <img
                                                        src={
                                                            auth
                                                                ?.userProfileDetails
                                                                .profileImageUrl
                                                        }
                                                    />
                                                ) : (
                                                    <img
                                                        src={defaultProfilePic}
                                                    />
                                                )}
                                                <div
                                                    className="sb-prof-expanded__edit-btn"
                                                    onClick={() =>
                                                        setCropImageArea(true)
                                                    }
                                                >
                                                    <PencilIcon />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {cropImageArea && (
                                        <UiCropFileUploadForm
                                            setCropImageArea={setCropImageArea}
                                        />
                                    )}
                                    <div className="sb-prof-expanded__body">
                                        <Form
                                            onSubmit={submit}
                                            validate={onValidate}
                                            initialValues={{
                                                firstName:
                                                    auth?.userProfileDetails
                                                        .firstName,
                                                lastName:
                                                    auth?.userProfileDetails
                                                        .lastName,
                                                address:
                                                    auth?.userProfileDetails
                                                        .address,
                                                address1:
                                                    auth?.userProfileDetails
                                                        .address1,
                                                address2:
                                                    auth?.userProfileDetails
                                                        .address2,
                                                address3:
                                                    auth?.userProfileDetails
                                                        .address3,
                                                jobFunction:
                                                    auth?.userProfileDetails
                                                        .jobFunction,
                                            }}
                                            render={({
                                                handleSubmit,
                                                hasValidationErrors,
                                            }) => (
                                                <form onSubmit={validateSchema}>
                                                    <div className="sb-prof-expanded__personal-inf">
                                                        {!nameEditMode ? (
                                                            <div className="sb-prof-name">
                                                                <h3>
                                                                    {auth
                                                                        ?.userProfileDetails
                                                                        .firstName +
                                                                        " " +
                                                                        auth
                                                                            ?.userProfileDetails
                                                                            .lastName}
                                                                </h3>
                                                                <span
                                                                    onClick={() =>
                                                                        setNameEditMode(
                                                                            !nameEditMode,
                                                                        )
                                                                    }
                                                                >
                                                                    <PencilIcon />
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <ChangeProfileName
                                                                    changeProfileName={
                                                                        changeProfileName
                                                                    }
                                                                    setNameEditMode={
                                                                        setNameEditMode
                                                                    }
                                                                    userDetails={
                                                                        auth?.userProfileDetails
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </div>

                                                    <div className="sb-prof-expanded__about-inf">
                                                        <div className="sb-prof-expanded__designation">
                                                            <div className="sb-prof-job">
                                                                <h4>
                                                                    {
                                                                        auth
                                                                            ?.userProfileDetails
                                                                            .jobFunction
                                                                    }
                                                                </h4>
                                                            </div>
                                                            <div className="sb-prof-dealer">
                                                                {auth
                                                                    ?.userProfileDetails
                                                                    ?.roleId ==
                                                                participantTypeIds.TLC_PARTICIPANT ? (
                                                                    <div className="sb-prof-dealer-mode">{`${auth?.userProfileDetails?.tlcCustomerNo} ${auth?.userProfileDetails?.tlcCustomerName}`}</div>
                                                                ) : (
                                                                    <div className="sb-prof-dealer-mode">{`${auth?.userProfileDetails?.jobRole} ${auth?.dealerships?.dealerName}`}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="sb-prof-expanded__dtl-card">
                                                            <>
                                                                <span>
                                                                    Email :{" "}
                                                                    <a
                                                                        href={
                                                                            "mailto:" +
                                                                            auth
                                                                                ?.userProfileDetails
                                                                                .email
                                                                        }
                                                                    >
                                                                        {
                                                                            auth
                                                                                ?.userProfileDetails
                                                                                .email
                                                                        }
                                                                    </a>
                                                                </span>
                                                                <div className="sb-prof-mobile">
                                                                    Mobile :{" "}
                                                                    <span
                                                                        className={
                                                                            mobileShow
                                                                                ? "sb-prof-tp-no"
                                                                                : "sb-prof-tp-no sb-tp-no-security"
                                                                        }
                                                                    >
                                                                        {
                                                                            auth
                                                                                ?.userProfileDetails
                                                                                .phoneNumber
                                                                        }{" "}
                                                                    </span>
                                                                    <div
                                                                        onClick={() =>
                                                                            setMobileShow(
                                                                                !mobileShow,
                                                                            )
                                                                        }
                                                                    >
                                                                        {mobileShow ? (
                                                                            <EyeIconCross />
                                                                        ) : (
                                                                            <EyeIcon />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        </div>
                                                        <div className="sb-prof-expanded__address-label">
                                                            <span
                                                                style={
                                                                    workAddress
                                                                        ? {
                                                                              backgroundColor:
                                                                                  "#F9E721",
                                                                              color: "black",
                                                                          }
                                                                        : {
                                                                              backgroundColor:
                                                                                  "",
                                                                          }
                                                                }
                                                                onClick={
                                                                    toggleWorkAddress
                                                                }
                                                            >
                                                                Work Address
                                                            </span>
                                                            <span
                                                                style={
                                                                    homeAddress
                                                                        ? {
                                                                              backgroundColor:
                                                                                  "#F9E721",
                                                                              color: "black",
                                                                          }
                                                                        : {
                                                                              backgroundColor:
                                                                                  "",
                                                                          }
                                                                }
                                                                onClick={
                                                                    toggleHomeAddress
                                                                }
                                                            >
                                                                Home Address
                                                            </span>
                                                        </div>

                                                        <div className="sb-prof-expanded__inf-card">
                                                            {homeAddress && (
                                                                <>
                                                                    <div className="sb-prof-address-wr">
                                                                        {/* <WorldIcon /> */}
                                                                        {!addressEditMode ? (
                                                                            <>
                                                                                <div className="sb-address-edit-section">
                                                                                    <div>
                                                                                        <p>
                                                                                            Address
                                                                                            :
                                                                                        </p>
                                                                                        <p>
                                                                                            {
                                                                                                auth
                                                                                                    ?.userProfileDetails
                                                                                                    ?.participantHomeAddress
                                                                                                    ?.no
                                                                                            }
                                                                                        </p>
                                                                                        <p>
                                                                                            {
                                                                                                auth
                                                                                                    ?.userProfileDetails
                                                                                                    ?.participantHomeAddress
                                                                                                    ?.addressLine1
                                                                                            }
                                                                                        </p>
                                                                                        <p>
                                                                                            {
                                                                                                auth
                                                                                                    ?.userProfileDetails
                                                                                                    ?.participantHomeAddress
                                                                                                    ?.addressLine2
                                                                                            }
                                                                                        </p>
                                                                                        <p>
                                                                                            {
                                                                                                auth
                                                                                                    ?.userProfileDetails
                                                                                                    ?.participantHomeAddress
                                                                                                    ?.town
                                                                                            }
                                                                                        </p>
                                                                                        <p>
                                                                                            {
                                                                                                auth
                                                                                                    ?.userProfileDetails
                                                                                                    ?.participantHomeAddress
                                                                                                    ?.postalCode
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                    <span
                                                                                        onClick={() =>
                                                                                            setAddressEditMode(
                                                                                                !addressEditMode,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <PencilIcon />
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <div className="sb-home-address-edit-input">
                                                                                <span>
                                                                                    <label>
                                                                                        Address
                                                                                        :{" "}
                                                                                    </label>
                                                                                </span>
                                                                                <ChangeAddress
                                                                                    handleCancel={
                                                                                        setAddressEditMode
                                                                                    }
                                                                                    changeHomeAddress={
                                                                                        changeHomeAddress
                                                                                    }
                                                                                    userDetails={
                                                                                        auth?.userProfileDetails
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                            {workAddress && (
                                                                <>
                                                                    <div className="sb-work-address-section">
                                                                        {auth
                                                                            ?.dealerships
                                                                            ?.participantWorkAddress
                                                                            ?.addressLine1 && (
                                                                            <>
                                                                                {auth
                                                                                    ?.dealerships
                                                                                    ?.participantWorkAddress
                                                                                    ?.addressLine1 !==
                                                                                "" ? (
                                                                                    <p>
                                                                                        {" "}
                                                                                        Address:{" "}
                                                                                        {
                                                                                            auth
                                                                                                ?.dealerships
                                                                                                ?.participantWorkAddress
                                                                                                ?.addressLine1
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                        {auth
                                                                            ?.dealerships
                                                                            ?.participantWorkAddress
                                                                            ?.addressLine2 && (
                                                                            <>
                                                                                {auth
                                                                                    ?.dealerships
                                                                                    ?.participantWorkAddress
                                                                                    ?.addressLine2 !==
                                                                                "" ? (
                                                                                    <p>
                                                                                        {" "}
                                                                                        Address
                                                                                        Line
                                                                                        Two:{" "}
                                                                                        {
                                                                                            auth
                                                                                                ?.dealerships
                                                                                                ?.participantWorkAddress
                                                                                                ?.addressLine2
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                        {auth
                                                                            ?.dealerships
                                                                            ?.participantWorkAddress
                                                                            ?.town && (
                                                                            <>
                                                                                {auth
                                                                                    ?.dealerships
                                                                                    ?.participantWorkAddress
                                                                                    ?.town !==
                                                                                "" ? (
                                                                                    <p>
                                                                                        {" "}
                                                                                        City:{" "}
                                                                                        {
                                                                                            auth
                                                                                                ?.dealerships
                                                                                                ?.participantWorkAddress
                                                                                                ?.town
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                        {auth
                                                                            ?.dealerships
                                                                            ?.participantWorkAddress
                                                                            ?.postalCode && (
                                                                            <>
                                                                                {auth
                                                                                    ?.dealerships
                                                                                    ?.participantWorkAddress
                                                                                    ?.postalCode !==
                                                                                "" ? (
                                                                                    <p>
                                                                                        {" "}
                                                                                        Postal
                                                                                        Code:{" "}
                                                                                        {
                                                                                            auth
                                                                                                ?.dealerships
                                                                                                ?.participantWorkAddress
                                                                                                ?.postalCode
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </form>
                                            )}
                                        />
                                    </div>
                                </div>
                            </UiNavTab>
                            <UiNavTab eventKey="Security" title="Security">
                                <div className="sb-prof-expanded__security">
                                    {!otpVerifyShow ? (
                                        <>
                                            <h4> Change Password </h4>
                                            <ChangePassword
                                                handlePwdUpdate={
                                                    handlePwdUpdate
                                                }
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <h4> OTP Verification </h4>
                                            <ChangePasswordOtpVerification
                                                handleOtpVerify={
                                                    handleOtpVerify
                                                }
                                            />
                                        </>
                                    )}
                                    <div className="sb-change-mobile-number">
                                        {!otpMobileVerifyShow ? (
                                            <>
                                                <h4> Change Mobile Number </h4>
                                                <ChangeMobileNumber
                                                    handleMobileUpdate={
                                                        handleMobileUpdate
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <h4> OTP Verification </h4>
                                                <ChangePasswordOtpVerification
                                                    handleOtpVerify={
                                                        handleOtpMobileChangeVerify
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </UiNavTab>
                            <UiNavTab
                                eventKey="Notification"
                                title="Notification"
                            >
                                <NotificationForm
                                    preValues={
                                        auth?.userProfileDetails
                                            ?.participantNotificationPreference
                                    }
                                />
                            </UiNavTab>
                        </UiNavTabs>
                        <div className="sb-prof-footer-section">
                            <div
                                className="sb-terms-of-use"
                                onClick={showTermsModal}
                            >
                                <h5>Rules & Terms of Use</h5>
                            </div>
                            <div className="sb-inner-privacy-wr">
                                <h5 onClick={showPrivacyModal}>Privacy</h5>
                            </div>
                            <img
                                src={FooterTermsLogo}
                                onClick={showCookieModal}
                            />
                        </div>
                    </div>
                </animated.div>
            </div>
        </>
    );
};
